// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"1fee3f77","422":"16c4eedd","457":"c5b0ad35","492":"ab2b3f61","640":"20f81160","695":"e0c69cfe","727":"dfb21420","771":"19ecf590","828":"27bb793e","851":"36062e6d"}[chunkId] + ".chunk.js";
};